export function SvgLink() {
  return (
    <svg
      style={{ display: 'inline', height: '0.8em', width: '0.8em' }}
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1667 10.6667H1.83333V1.33333H6.5V0H1.83333C1.09333 0 0.5 0.6 0.5 1.33333V10.6667C0.5 11.4 1.09333 12 1.83333 12H11.1667C11.9 12 12.5 11.4 12.5 10.6667V6H11.1667V10.6667ZM7.83333 0V1.33333H10.2267L3.67333 7.88667L4.61333 8.82667L11.1667 2.27333V4.66667H12.5V0H7.83333Z"
        fill="#C48F1C"
      />
    </svg>
  );
}
